import { render, staticRenderFns } from "./Blitz.vue?vue&type=template&id=45bf3d1c&scoped=true&"
import script from "./Blitz.vue?vue&type=script&lang=js&"
export * from "./Blitz.vue?vue&type=script&lang=js&"
import style0 from "./Blitz.vue?vue&type=style&index=0&id=45bf3d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf3d1c",
  null
  
)

export default component.exports